/**
 * Voice-mode transcription API client.
 *
 * Multipart endpoint, so it bypasses `apiFetch` (the browser must set the
 * multipart boundary on Content-Type itself — see api/attachments.ts for the
 * same reasoning). The audio Blob is sent as the `file` field and dropped
 * server-side; only the transcript comes back.
 */
import { tokenStorage } from "@/auth/storage";

import { throwApiRequestError } from "./client";
import type { TranscribeResponse } from "./generated";

function authHeaders(): Record<string, string> {
  const headers: Record<string, string> = { Accept: "application/json" };
  const tokens = tokenStorage.load();
  if (tokens?.access_token) {
    headers.Authorization = `Bearer ${tokens.access_token}`;
  }
  return headers;
}

export async function transcribeAudio(
  audio: Blob,
  filename = "audio.webm",
): Promise<TranscribeResponse> {
  const fd = new FormData();
  fd.append("file", audio, filename);
  const res = await fetch("/api/v1/transcribe", {
    method: "POST",
    headers: authHeaders(),
    body: fd,
  });
  if (!res.ok) {
    await throwApiRequestError(res);
  }
  return (await res.json()) as TranscribeResponse;
}
